import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHead, TableCell, TableRow } from './TableComponents';
import { COLOR } from '../Theme';
import { Box } from 'rebass';

const HeaderCell = props => <TableCell fontWeight="bold" {...props} />;

const getAnswer = (isCorrect, questionType) => {
  if (questionType === 'TOPIC') {
    return { text: '-', color: null };
  }

  switch (isCorrect) {
    case true:
      return { text: 'ถูก', color: COLOR.success };
    case false:
      return { text: 'ผิด', color: COLOR.danger };
    default:
      return { text: '-', color: null };
  }
};

const SolutionListTable = ({ rows, renderActionRow }) => {
  return (
    <Box style={{ overflowX: 'auto' }}>
      <Table minWidth={'700px'} padding={'checkbox'}>
        <TableHead>
          <TableRow type={'head'} bgColor={COLOR.gridGrey} height="48px">
            <HeaderCell>ข้อที่</HeaderCell>
            <HeaderCell>หัวข้อ</HeaderCell>
            <HeaderCell>โจทย์</HeaderCell>
            <HeaderCell>ตอบ</HeaderCell>
            <HeaderCell>เฉลยเพิ่มเติม</HeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => {
            const answerColor = getAnswer(row.correct, row.questionType).color;
            const answerText = getAnswer(row.correct, row.questionType).text;
            return (
              <TableRow key={row.id}>
                <TableCell>{row.itemNumber}</TableCell>
                <TableCell minWidth={'176px'} maxWidth={'176px'}>
                  {row.topic}
                </TableCell>
                <TableCell width={'100%'} minWidth={'507px'} maxWidth={'507px'}>
                  {row.questionTitle}
                </TableCell>
                <TableCell color={answerColor}>{answerText}</TableCell>

                <TableCell>{renderActionRow(row, rows.length)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

SolutionListTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      topic: PropTypes.string,
      questionIndex: PropTypes.number,
      itemNumber: PropTypes.number,
      questionTitle: PropTypes.string,
      questionType: PropTypes.string,
      correct: PropTypes.bool,
    })
  ),
  onClick: PropTypes.func,
  renderActionRow: PropTypes.func,
};

SolutionListTable.defaultProps = {
  rows: [],
  renderActionRow: () => null,
};

export default SolutionListTable;
